import { fonts, fontSizes } from '@opallabs/pulsar'
import { colors } from '@opallabs/spectrum'

const progressWrapper = {
  left: '50%',
  position: 'absolute',
  top: '50%',
  transform: 'translate(-50%, -50%)',
}

const progressBar = {
  backgroundColor: colors.n1.base,
  borderColor: colors.n1.base,
  marginBottom: 10,
  width: 100,
}

const progressText = {
  color: colors.n6.base,
  fontFamily: fonts.sourceCode,
  fontSize: fontSizes.xSmall,
}

const backgroundColor = ({ placeholder, loaded, hasAsset }) => {
  if (placeholder) return colors.n8.base
  if (!loaded && hasAsset) return colors.n4.base

  return 'transparent'
}

const assetBase = {
  alignItems: 'center',
  boxSizing: 'border-box',
  display: 'flex',
  justifyContent: 'center',
  position: 'relative',
}

const asset = ({ placeholder, loaded, hasAsset }) => ({
  backgroundColor: backgroundColor({ placeholder, loaded, hasAsset }),
  boxSizing: 'border-box',
  height: '100%',
  width: '100%',
})

const fillColor = colors.n6.base

export const styles = {
  asset,
  assetBase,
  progressBar,
  progressText,
  progressWrapper,
  fillColor,
}
